export const navigateAway = (path) => {
  const baseURL = 'https://www.fwcanvass.com';
  window.location = baseURL + path;
};
